import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

import { ConfirmDialogData } from "src/app/components/dialogs/confirm-dialog/confirm-dialog.component";
import { DialogService } from "src/app/core/core-services/services/dialog.service";

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
  confirmLeave: () => void;
}

/** Shared "leave persona editor?" confirmation, also used by the editor's own Back button. */
export const LEAVE_PERSONA_CONFIRM: ConfirmDialogData = {
  title: "Cancel Persona Creation",
  message:
    "Are you sure you want to leave this page?<br />Your progress will be lost and the persona will not be saved.",
  confirmLabel: "Leave Without Saving",
  showClose: true,
};

@Injectable({
  providedIn: "root",
})
export class CanDeactivateFormGuard {
  constructor(
    private readonly dialog: DialogService,
    private readonly router: Router
  ) {}

  canDeactivate(component: CanComponentDeactivate, _, __, next): Observable<boolean> | Promise<boolean> | boolean {
    if (!component.canDeactivate()) {
      this.dialog.confirm(LEAVE_PERSONA_CONFIRM, { width: "480px" }).subscribe((leave) => {
        if (leave) {
          component.confirmLeave();
          const decodedUrl = decodeURIComponent(next.url);
          const urlParts = decodedUrl.split("?");
          const baseUrl = urlParts[0];
          const queryParams = urlParts.length > 1 ? urlParts[1] : "";

          this.router.navigate([baseUrl], {
            queryParams: queryParams
              ? JSON.parse(`{"${decodeURIComponent(queryParams.replace(/&/g, '","').replace(/=/g, '":"'))}"}`)
              : {},
          });
        }
      });

      return false;
    }
    return true;
  }
}
